/* =========================================================
   NA LEIBERL – Sitzende Taube auf der Footer-Oberkante
   Bild: window.NL_TAUBE.sitzt (in snippets/meta-tags.liquid)
   - blinzelt in zufälligen Abständen, ab und zu doppelt
   - raucht (animierter Rauch als SVG)
   - sagt einen zufälligen Spruch:
     Desktop beim Drüberfahren, Handy beim Antippen
   ========================================================= */
(function () {
  'use strict';

  var CONFIG = {
    blinzelnMin: 2500,   // ms bis zum nächsten Blinzeln (min)
    blinzelnMax: 6000,   // ms (max)
    zuDauer: 140,        // ms, wie lange die Augen zu sind
    doppeltChance: 0.25, // Anteil der Doppel-Blinzler
    blaseNachlauf: 700,  // ms, so lange bleibt die Blase nach dem Wegfahren (Desktop)
    blaseHandy: 2600     // ms, so lange bleibt die Blase nach dem Antippen (Handy)
  };

  // Sprüche für die Sprechblase (hier anpassen)
  var SPRUECHE = [
    'Oida.',
    'Eh scho wissen.',
    'Schleich di.',
    'Wos schaust?',
    'Passt scho.',
    'Geh bitte.',
    'Na servas.',
    'Is ma wurscht.',
    'Heast!',
    'Mahlzeit.'
  ];

  // Rauch: drei Schwaden, die versetzt aufsteigen (viewBox 824 x 869)
  var RAUCH_PFAD = 'M774 300C792 280 760 262 770 238S806 200 796 176S770 140 786 112';
  var RAUCH =
    '<path class="nl-rauch nl-rauch--1" d="' + RAUCH_PFAD + '"/>' +
    '<path class="nl-rauch nl-rauch--2" d="' + RAUCH_PFAD + '"/>' +
    '<path class="nl-rauch nl-rauch--3" d="' + RAUCH_PFAD + '"/>';

  // Lider passend zur Grafik
  var LIDER =
    '<g class="nl-sitz__auge">' +
      '<path class="nl-sitz__lid" d="M436 195 H554 V229 Q495 247 436 229 Z" fill="#fff"/>' +
      '<path class="nl-sitz__strich" d="M440 228 Q495 245 551 226" stroke="#211D1E" stroke-width="11" fill="none" stroke-linecap="round"/>' +
    '</g>' +
    '<g class="nl-sitz__auge">' +
      '<path class="nl-sitz__lid" d="M600 189 H648 V204 Q624 213 600 204 Z" fill="#fff"/>' +
      '<path class="nl-sitz__strich" d="M602 203 Q624 212 646 202" stroke="#211D1E" stroke-width="10" fill="none" stroke-linecap="round"/>' +
    '</g>';

  function einbauen() {
    var cfg = window.NL_TAUBE || {};
    if (!cfg.sitzt) return;
    if (document.querySelector('.nl-sitz')) return;

    var host = document.querySelector('.shopify-section-group-footer-group');
    if (!host) return;
    host.classList.add('nl-sitz-host');

    var el = document.createElement('div');
    el.className = 'nl-sitz';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="nl-sitz__koerper">' +
        '<img src="' + cfg.sitzt + '" alt="" width="824" height="869" loading="lazy" decoding="async">' +
        '<svg viewBox="0 0 824 869" xmlns="http://www.w3.org/2000/svg">' + RAUCH + LIDER + '</svg>' +
      '</div>' +
      '<div class="nl-sitz__blase"></div>';
    host.appendChild(el);

    var blase = el.querySelector('.nl-sitz__blase');
    var letzter = -1;
    var weg = null;
    var mitMaus = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function zufall(a, b) { return a + Math.random() * (b - a); }

    function blinzeln(dann) {
      el.classList.add('is-zu');
      setTimeout(function () {
        el.classList.remove('is-zu');
        if (dann) setTimeout(dann, 160);
      }, CONFIG.zuDauer);
    }

    // neuen Spruch zeigen (nie zweimal hintereinander derselbe)
    function sagen() {
      var i;
      do { i = Math.floor(Math.random() * SPRUECHE.length); } while (i === letzter && SPRUECHE.length > 1);
      letzter = i;
      blase.textContent = SPRUECHE[i];
      el.classList.add('is-redet');
    }

    function verstummen(nach) {
      clearTimeout(weg);
      weg = setTimeout(function () { el.classList.remove('is-redet'); }, nach);
    }

    // Desktop: Drüberfahren
    el.addEventListener('mouseenter', function () {
      if (!mitMaus) return;
      clearTimeout(weg);
      if (!el.classList.contains('is-redet')) sagen();
    });
    el.addEventListener('mouseleave', function () {
      if (!mitMaus) return;
      verstummen(CONFIG.blaseNachlauf);
    });

    // Klick / Antippen: immer ein neuer Spruch
    el.addEventListener('click', function () {
      clearTimeout(weg);
      sagen();
      if (!mitMaus) verstummen(CONFIG.blaseHandy);
    });

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function naechstes() {
      setTimeout(function () {
        if (!document.hidden) {
          if (Math.random() < CONFIG.doppeltChance) blinzeln(function () { blinzeln(); });
          else blinzeln();
        }
        naechstes();
      }, zufall(CONFIG.blinzelnMin, CONFIG.blinzelnMax));
    }
    naechstes();

    // Test-Helfer in der Konsole: nlBlinzeln()
    window.nlBlinzeln = function () { blinzeln(); };
  }

  // Social-Media-Links im Footer in neuem Tab öffnen
  function socialsNeuerTab() {
    var links = document.querySelectorAll('.footer .list-social__link, .footer__list-social a');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('target', '_blank');
      links[i].setAttribute('rel', 'noopener noreferrer');
    }
  }

  // Logo-Platzhalter über "Über NA LEIBERL".
  // Echtes Logo: in meta-tags.liquid bei NL_TAUBE  footerLogo: "{{ 'datei.svg' | asset_url }}"  ergänzen.
  function footerLogo() {
    var block = document.querySelector('.footer__blocks-wrapper .footer-block');
    if (!block || block.querySelector('.nl-footer-logo')) return;
    var box = document.createElement('div');
    box.className = 'nl-footer-logo';
    var url = (window.NL_TAUBE || {}).footerLogo;
    if (url) {
      box.classList.add('has-logo');
      box.innerHTML = '<img src="' + url + '" alt="NA LEIBERL" loading="lazy">';
    } else {
      box.setAttribute('aria-hidden', 'true');
      box.textContent = 'Logo';
    }
    block.insertBefore(box, block.firstChild);
  }

  function start() {
    einbauen();
    socialsNeuerTab();
    footerLogo();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
